import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'GCADA-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class GCADAWidgetComponent {


    /**
     * Constructor
     *
     */
    constructor() { }

}
